<template>
    <div class="Biennale">
        <div class="Biennale__container">
            <div class="Biennale__header">
                <div class="Biennale__title" v-html="trans('PAGES.BIENNALE.title')"/>
                <div class="Biennale__subtitle">{{ trans('PAGES.BIENNALE.texte') }}</div>
            </div>
            <div class="Biennale__desc"> 
                <div v-html="trans('PAGES.BIENNALE.description')" /> 
            </div>       
        </div>
        <div class="Biennale__arrow">
            <div ref="back" class="Complements__back" :class="{ 'white': is_white }" @click="callBack()">
                <img :src="require('@/commons/img/back.png')">
            </div>
        </div>
        <div class="Biennale__trigger""/>
    </div>
</template>

<script>

import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default {
    name: 'Biennale',
    data: ()=>({
        is_white: false
    }),
    beforeCreate() {
        window.scrollTo(0,0)
    },
    mounted() {
        gsap.from(this.$refs.back, { duration: .35, x: 30, delay: .2, alpha: 0 })
        this.$nextTick(()=>{
            this.$scr = ScrollTrigger.create({
                scroller: '#complements',
                trigger: '.Biennale__trigger',
                start: "top 0",
                toggleActions: "restart pause reverse none",
                scrub: true,
                onEnter: ()=>{ this.is_white = true },
                onLeaveBack: ()=>{ this.is_white = false },
                markers: false
            }) 
        })
    },
    methods: { 
        callBack() {
            gsap.delayedCall(.15, ()=>{ this.$parent.step = 'left' })
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Biennale 

    display flex
    position absolute 
    width 100vw
    top 0

    &__arrow
        position fixed
        width 100%
   
    &__container
        display flex
        align-items flex-center
        justify-content center
        flex-direction column
        padding 36px 30px 208px
        width 100%

    &__header
        display flex
        flex-direction column
        width 100%
        padding-bottom 48px

    &__title 
        font-weight 800
        font-size 22px
        text-align center
        line-height 24px
        text-transform uppercase
        padding-bottom 8px

        &-sub 
            font-weight 700

    &__subtitle 
        text-align center
        font-size 16px
        text-transform uppercase

    &__groupe
        font-weight 700
        padding 8px 0 32px
        font-size 18px
        line-height 20px

    &__desc 
        display flex
        align-items flex-center
        justify-content center
        flex-direction column
        text-align left
        font-weight 200
        font-size 16px

    &__sub
        padding-bottom 32px
        font-size 16px

    ul
        padding 0 0 0 32px
        list-style-image url('./img/line.png')
        list-style-position outside
      
        li
            font-family Ringside
            font-size 16px
            font-weight 200
            padding 0 0 16px 8px

    &__trigger
        width 20vw
        height 1px
        // border 1px solid red
        top 60px
        position absolute
      
</style>














